import { BlogSection } from '@/types/blog';

export const quellen: BlogSection = {
  id: 'quellen',
  title: 'Quellen',
  content: `
    <ul class="text-sm text-joerg-600 dark:text-joerg-400 space-y-2">
      <li>Blood AJ, Zatorre RJ. Intensely pleasurable responses to music correlate with activity in brain regions implicated in reward and emotion. PNAS. 2001.</li>
      <li>Knutson B, et al. Neural responses to monetary incentives in the human nucleus accumbens. Neuron. 2001.</li>
      <li>Bernardi L, Porta C, Sleight P. Cardiovascular, cerebrovascular, and respiratory changes induced by different types of music in musicians and nonmusicians: The importance of silence. Heart. 2006.</li>
      <li>Koelsch S. Brain correlates of music-evoked emotions. Nature Reviews Neuroscience. 2014; 15:170-180.</li>
      <li>Mas-Herrero E, et al. Individual differences in music reward experiences. Frontiers in Neuroscience. 2021.</li>
      <li>Thoma MV, et al. The effect of music on the human stress response. PLoS ONE. 2013; 8(8):e70156.</li>
    </ul>
  `
};
